import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { getDateFormat } from '../../utils/dateFormat';
import { ReactComponent as CloseIcon } from '../../assets/img/close.svg';
import '../../assets/styles/ride-history.sass';

const RideHistory = ({ closeRideHistoryHandler }) => {
  const context = useContext(BookerContext);
  const {
    state: { userId, rideDetailsHistory },
    updateRideDetailsHistory,
    updateRideDetailsReceipt,
  } = context;
  const { pickup = '', dropoff = '' } = useSelector(({ upcomingRideLocations }) => upcomingRideLocations || {});
  const dispatch = useDispatch();

  const { loading, setLoading } = useContext(BookerShortContext);
  const [rides, setRides] = useState(null);
  const [error, setError] = useState(false);
  const [hiddenArea, setHiddenArea] = useState(false);

  useEffect(() => {
    setLoading(true);
    updateRideDetailsHistory(null);
    updateRideDetailsReceipt(null);

    getRides();
  }, []);

  useEffect(() => {
    setHiddenArea(!!rideDetailsHistory);
  }, [updateRideDetailsHistory, setHiddenArea]);

  const getRides = () => {
    let ridesArray = [];

    const processArray = async () => {
      const rideTypes = ['upcoming', 'active', 'past'];
      for (const filter of rideTypes) {
        const data = {
          filterBy: filter,
          userId: userId,
        };

        if (filter === 'upcoming') {
          data.search_ride_status = 'riderway_submitted';
        } else if (filter === 'past') {
          data.search_ride_status = 'completed,missed';
        }

        await FetchService.getWebApiResource(urlService.gerUserRides(data))
          .then(response => {
            let ridesResponse = response.rides;

            ridesResponse = ridesResponse.filter(item => {
              item.ride_type = filter;
              item.pickupFormatted =
                filter === 'upcoming'
                  ? 'Upcoming Ride'
                  : getDateFormat(item.pickup_time_local, 'MMMM d yyyy, h:mm aa', true);

              if (filter === 'upcoming') {
                return (
                  item.ride_status_code !== 'canceled' &&
                  item.ride_status_code !== 'missed' &&
                  item.ride_status_code !== 'completed'
                );
              }
              return true;
            });

            ridesArray.push(...ridesResponse);
          })
          .catch(error => {
            setError(true);
          });
      }

      setRides(ridesArray);
      setError(false);
      setLoading(false);
      return true;
    };

    processArray();
  };

  const getPaidStatus = item => {
    const billState = item.bill_state;

    if (item.cancel_fee_amount) return 'Cancel Fee';

    return billState;
  };

  const rideClickHandler = (elem, ride) => {
    rides.map(item => {
      item.selected = item.ride_id === ride.ride_id;
    });
    updateRideDetailsReceipt(null);
    if (ride.ride_type === 'upcoming') {
      updateRideDetailsHistory(null);
      const { pickup_latitude, pickup_longitude, dropoff_latitude, dropoff_longitude } = ride;
      dispatch({
        type: 'updateUpcomingRideLocations',
        upcomingRideLocations: {
          pickup: { simple: { latitude: pickup_latitude, longitude: pickup_longitude } },
          dropoff: { simple: { latitude: dropoff_latitude, longitude: dropoff_longitude } },
        },
      });
      return;
    }

    updateRideDetailsHistory(ride);
    if (pickup || dropoff) {
      dispatch({
        type: 'updateUpcomingRideLocations',
        upcomingRideLocations: '',
      });
    }
  };

  const HistoryContent = () => {
    if (loading) return <></>;

    if (!rides || !rides.length || error) return <div className="empty">No Rides</div>;

    return (
      <ul className={`history-dropdown-list clearfix ${hiddenArea ? 'hidden-list' : ''}`}>
        {rides.map(item => (
          <li
            className={`dropdown-item type-${item.ride_type} ${item.selected ? 'active' : ''} ${
              item.total_formatted ? 'item-with-price' : ''
            }`}
            key={item.ride_id}
            onClick={e => rideClickHandler(e, item)}
          >
            <div className="item">
              <div className="history-time">
                <span className={`${item.ride_type}-ride-time`}>{item.pickupFormatted}</span>
              </div>
              <div className="history-total">{item.total_formatted}</div>
            </div>
            <div className="item">
              <div className="history-location">
                <span className="history-dot pickup-dot" />
                {item.pickup_location}
              </div>
              <div className="history-status">{getPaidStatus(item)}</div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="form-group ride-history-container">
      <div className="details-header">
        <div className="title">Ride History</div>
        <CloseIcon className="details-hide-icon" onClick={closeRideHistoryHandler} />
      </div>
      <HistoryContent />
    </div>
  );
};

export default RideHistory;
